module.exports = __webpack_public_path__ + "img/galleria5.df4cc30.jpg";


//////////////////
// WEBPACK FOOTER
// ./showcase/src/assets/images/demo/galleria/galleria5.jpg
// module id = VjVt
// module chunks = 0